import React from "react";
import PageShell from "../common/page_shell";
import SinglePlayerGames from "../inner/games/single_player_games";

const GamesPage = () => {
  return (
    <PageShell>
      <SinglePlayerGames />
    </PageShell>
  );
};

export default GamesPage;
